import { TicketHistoryModal } from "@/components/Ticket/TicketHistoryModal";
import { Button } from "@/design-system/Button";
import { useBool } from "@/hooks/useBool";
import { CardActionPrompt, CardActionPromptDescription } from "@/product-patterns/tickets/CardActionPrompt";
import { useTranslation } from "@/translations";

type TicketHistoryCardProps = {
  ticketId: string;
};

export function TicketHistoryCard({ ticketId }: TicketHistoryCardProps): React.ReactNode {
  const { t } = useTranslation();
  const [isTicketHistoryModalOpen, ticketHistoryModalOpenHandlers] = useBool(false);

  return (
    <>
      <CardActionPrompt
        action={
          <Button data-testid="ticket-history-open" variant="soft" onClick={ticketHistoryModalOpenHandlers.setTrue}>
            {t("page.tickets.details.service-history.button")}
          </Button>
        }
      >
        <CardActionPromptDescription data-testid="ticket-history-description-primary">
          {t("page.tickets.details.service-history.description.1")}
        </CardActionPromptDescription>
        <CardActionPromptDescription data-testid="ticket-history-description-secondary">
          {t("page.tickets.details.service-history.description.2")}
        </CardActionPromptDescription>
      </CardActionPrompt>
      <TicketHistoryModal
        ticketId={ticketId}
        isOpened={isTicketHistoryModalOpen}
        onOpenChange={ticketHistoryModalOpenHandlers.set}
      />
    </>
  );
}
